export const USER_BALANCE = "USER_BALANCE"
export const USER_BALANCE_SUCCESS = "USER_BALANCE_SUCCESS"